/**
 * IMPORTS
 */

import countdownShortSound from '../assets/countdown_short.mp3';
import countdownLongSound from '../assets/countdown_long.mp3';
import countdown3Sound from '../assets/countdown-3.mp3';
import countdown5Sound from '../assets/countdown-5.mp3';
import triggerSound from '../assets/trigger.mp3';

/**
 * CORE
 */

const initial = {
  sounds: [
    { id: 'trigger', url: triggerSound },
    { id: 'countdown-short', url: countdownShortSound },
    { id: 'countdown-long', url: countdownLongSound },
    { id: 'countdown-3', url: countdown3Sound },
    { id: 'countdown-5', url: countdown5Sound },
  ],
  playing: {
    trigger: false,
    'countdown-short': false,
    'countdown-long': false,
    'countdown-3': false,
    'countdown-5': false,
  },
};

export default (state = initial, action) => {
  switch (action.type) {
    case 'PLAY_SOUND':
      return {
        ...state,
        playing: {
          ...state.playing,
          [action.sound]: true,
        },
      };

    case 'STOP_SOUND':
      return {
        ...state,
        playing: {
          ...state.playing,
          [action.sound]: false,
        },
      };

    default:
      return state;
  }
};
